import { useState } from "react";
import api, { API } from "@/lib/api";
import { toast } from "sonner";

const err = (e) => e.response?.data?.detail || e.message;

async function download(path, name) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function RegisterBar({ orderId, g, reload }) {
  const [busy, setBusy] = useState(null);
  const tag = g.order.quotation_code || orderId;
  const run = async (k, fn) => { setBusy(k); try { await fn(); } catch (e) { toast.error(err(e)); } finally { setBusy(null); } };
  const email = () => run("email", async () => {
    const to = window.prompt("Send the delivery summary + register to the customer contact (leave blank for the quotation contact):", "");
    if (to === null) return;
    const { data } = await api.post(`/quote-fulfilment/orders/${orderId}/register/email`, { to: to || null });
    toast[data.status === "SENT" ? "success" : "error"](data.status === "SENT" ? `Customer summary sent to ${data.to} (provider accepted)` : `${data.status}: ${data.error || ""}`);
    reload();
  });
  const ready = g.rows.filter((r) => r.shipment_id && r.welcome_label.status === "GENERATED").length;
  const last = (g.customer_comms || []).slice(-1)[0];
  const btn = "rounded-md border border-slate-300 bg-white px-2.5 py-1 text-[11px] font-semibold hover:bg-slate-50 disabled:opacity-40";
  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5" data-testid="fd-register-bar">
      <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">Serial / delivery register</span>
      <button className={btn} disabled={!!busy} onClick={() => run("x", () => download(`/quote-fulfilment/orders/${orderId}/register.xlsx`, `Delivery-Register-${tag}.xlsx`))} data-testid="fd-register-xlsx">Download Excel</button>
      <button className={btn} disabled={!!busy} onClick={() => run("p", () => download(`/quote-fulfilment/orders/${orderId}/register.pdf`, `Delivery-Register-${tag}.pdf`))} data-testid="fd-register-pdf">Download PDF</button>
      <button className={btn} disabled={!!busy} onClick={email} data-testid="fd-register-email">{busy === "email" ? "Sending…" : "Email customer"}</button>
      {last && <span className="text-[11px] text-slate-600" data-testid="fd-customer-comm">Customer: {last.subject} · {last.status} → {last.to}</span>}
      <a href={`${API}/welcome-label/orders/${orderId}/html?print=1`} target="_blank" rel="noreferrer" className={`ml-auto rounded-md bg-slate-900 px-2.5 py-1 text-[11px] font-semibold text-white ${ready ? "" : "pointer-events-none opacity-40"}`} data-testid="fd-print-all-labels">Print all ready labels ({ready})</a>
    </div>
  );
}
